module.exports = __webpack_public_path__ + "img/169.3aa1713f.jpg";